import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Materials } from "@/components/Materials";
import { Gallery } from "@/components/Gallery";
import { Process } from "@/components/Process";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-espresso-900 text-cream">
      <Navbar />
      <Hero />
      <Services />
      <Materials />
      <Gallery />
      <Process />
      <QuoteForm />
      <Footer />
    </main>
  );
}
